import { render } from "./property-descnew.vue?vue&type=template&id=06e57329"
import script from "./property-descnew.js?vue&type=script&lang=js"
export * from "./property-descnew.js?vue&type=script&lang=js"

import "./property-descnew.vue?vue&type=style&index=0&id=06e57329&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__